import React from 'react';
import { mapProps, compose } from 'recompose';
import ItemsSlider from 'js/components/common/ItemsSlider';
import { withEmptyState } from '../common/EmptyState';
import Card from './SliderCard';
import withSkeleton from './withSkeleton';
import fadeInCss from '../common/FadeInContainer/index.scss';
import style from './index.scss';

export const Slider = mapProps(
    ({ leaderboards = [] }) => ({
        Item: Card,
        items: leaderboards,
        className: fadeInCss.fadeIn
    })
)(ItemsSlider);

export const SingleCard = mapProps(
    ({ leaderboards: [card] }) => ({
        className: `${style.one} ${fadeInCss.fadeIn}`,
        isHorizontal: true,
        ...card
    })
)(Card);

export default compose(
    withSkeleton,
    withEmptyState
)(({ leaderboards = [], ...rest }) => {
    return leaderboards.length === 1
        ? <SingleCard {...{ leaderboards, ...rest }} />
        : <Slider {...{ leaderboards, ...rest }}/>;
});
